import { Route, BreadcrumbItem, BreadcrumbMap } from '../types'

export function normalizePath(...segments: (string | undefined)[]): string {
  const filtered = segments
    .filter((segment): segment is string => Boolean(segment?.trim()))
    .map((segment) => segment.replace(/^\/+|\/+$|\s+/g, ''))
    .filter(Boolean)
  if (filtered.length === 0) return '/'
  return `/${filtered.join('/')}`.replace(/\/+$/, '') || '/'
}

export function buildCrumb(
  routes: Route[],
  parentPath = '',
  parentBreadcrumb: BreadcrumbItem[] = []
): BreadcrumbMap {
  const result: BreadcrumbMap = {}
  for (const route of routes) {
    const routePath = route.path ?? ''
    const currentPath = normalizePath(parentPath, routePath)
    const breadcrumb: BreadcrumbItem[] = [...parentBreadcrumb]
    if (route.name) {
      breadcrumb.push({
        label: route.name,
        href: currentPath,
        icon: route.icon ?? null,
      })
      result[currentPath] = breadcrumb
    }
    if (route.children?.length) {
      Object.assign(result, buildCrumb(route.children, currentPath, breadcrumb))
    }
  }
  return result
}

export function getBreadcrumbForPath(routeMap: BreadcrumbMap, path: string): BreadcrumbItem[] {
  if (routeMap[path]) return routeMap[path]
  const pathSegments = path.split('/').filter(Boolean)
  for (const routeKey of Object.keys(routeMap)) {
    const routeSegments = routeKey.split('/').filter(Boolean)
    if (routeSegments.length === pathSegments.length) {
      let matches = true
      for (let i = 0; i < routeSegments.length; i++) {
        if (routeSegments[i].startsWith(':')) continue
        if (routeSegments[i] !== pathSegments[i]) {
          matches = false
          break
        }
      }
      if (matches) return routeMap[routeKey]
    }
  }
  for (let i = pathSegments.length - 1; i >= 0; i--) {
    const testPath = normalizePath(...pathSegments.slice(0, i))
    if (routeMap[testPath]) return routeMap[testPath]
  }
  return []
}
